import FormData from "csi/action/FormData";
import { Context } from "csi/def/Context";
import { isSustainabilityProfileFormAttribute } from "csi/model/sustainabilityProfile";
import AggregateFrom from "csi/table/AggregateFrom";
import declare from "dojo/_base/declare";
import lang from "dojo/_base/lang";

const AggregateFromFormDefinition = declare(AggregateFrom, {

	/**
	 * @override
	 * Set AggregateTest to use _canAggregate to limit selection of FormAttributes
	 */
	getFormData(): FormData {
		var fd = this.inherited(arguments) as unknown as FormData;
		fd.m_fAggregateTest = lang.hitch(this, this._canAggregate);
		return fd;
	},

	/**
	 * Return false if the node is an attribute on SustainabilityProfile's default form so that the user cannot remove/add it
	 */
	_canAggregate(ctx: Context, fd: FormData): boolean {
		return !isSustainabilityProfileFormAttribute(ctx.getNode());
	},

});

export = AggregateFromFormDefinition;
